export const APARTMENT_LIST_LOCATION_FILTER = 'APARTMENT_LIST_LOCATION_FILTER';
export const APARTMENT_LIST_PRICE_FILTER = 'APARTMENT_LIST_PRICE_FILTER';
export const APARTMENT_LIST_ZIP_FILTER = 'APARTMENT_LIST_ZIP_FILTER';
export const APARTMENT_LIST_FRONTPAGE_LOCATION_FILTER = 'APARTMENT_LIST_FRONTPAGE_LOCATION_FILTER';
export const APARTMENT_LIST_FRONTPAGE_ROOM_COUNT_FILTER = 'APARTMENT_LIST_FRONTPAGE_ROOM_COUNT_FILTER';
export const APARTMENT_LIST_FRONTPAGE_PRICE_FILTER = 'APARTMENT_LIST_FRONTPAGE_PRICE_FILTER';
